import React from "react"

import { WebSource } from "../../../../../../model/types"
import SourceMarkdownView from "./source_markdown_view"

export default function ExtractedText({ source }: { source: WebSource }) {
  return <SourceMarkdownView source={source} />
}
